module.exports = __webpack_public_path__ + "static/media/wellnite-auth-hero_1340.4ffcb49d.webp";